import { UserLevelType } from "~/common/constants"

export const isProfessionalUser = (user: API.User.SessionUser | undefined) => {
  const levelInfo = user?.level_info

  return (
    levelInfo?.level_code === UserLevelType.pro &&
    levelInfo.level_effective_until != null &&
    levelInfo.level_effective_until > Math.floor(Date.now() / 1000)
  )
}
